import { render, staticRenderFns } from "./WaveLoader.vue?vue&type=template&id=490ee829&scoped=true"
import script from "./WaveLoader.vue?vue&type=script&lang=ts"
export * from "./WaveLoader.vue?vue&type=script&lang=ts"
import style0 from "./WaveLoader.vue?vue&type=style&index=0&id=490ee829&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ee829",
  null
  
)

export default component.exports